<template src="./AuthCard.html"></template>

<script lang="ts">
import logo from "@/assets/img/BMWGroup_BMW_MINI_White-Colour_RGB.png";

import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            logo
        };
    }
});
</script>

<style src="./AuthCard.scss" lang="scss" scoped></style>
